// Webpack Imports
import * as bootstrap from 'bootstrap';
 
import { Fancybox } from "@fancyapps/ui";
 
import Swiper, { Navigation, Pagination, EffectCards, Autoplay   } from 'swiper';

//import { Gradient } from './Gradient.js'

Swiper.use([EffectCards, Autoplay]);

import { Calendar } from 'fullcalendar';
import esLocale from '@fullcalendar/core/locales/es';
import caLocale from '@fullcalendar/core/locales/ca';


import * as THREE from 'three';
import { OrbitControls } from 'three/addons/controls/OrbitControls.js';
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';

import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader'

import { gsap } from 'gsap';
// import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
//import { ScrollSmoother } from 'gsap/ScrollSmoother';

import { do3D } from  './tresde';

 
// import {ScrollMagic} from "scrollmagic";
// ScrollMagic.registerGSAP(gsap);

//console.log(do3D);
 
//  import { SplitText } from 'gsap/SplitText';
 
 //import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';

 gsap.registerPlugin( ScrollTrigger     );


 import Splitting from "splitting";


//console.log('Splitting');

//console.log(Splitting);

 //
//http://localhost:3000/laia/

//  //console.log('SplitText aaa');
//  //console.log(SplitText);

//console.log('>>>>>>>>>>>>> aaa');

 let smoother ;

 let controller;
  
let jsonListo = new Object();
let tiempo =0;

let  miScrollBar;

let jsonListoDias = new Object();

let swiperHome;

let miJSON;


let hayTelon = false;
let telon;

let body = document.getElementsByTagName('body');
body = body[0];


let feedES; 
let feedVAL;

if(body){
	feedES = body.dataset.feedes;
	feedVAL = body.dataset.feedval;

	var eventSourceLink;

	if (document.documentElement.lang === "es-ES") {
		eventSourceLink = feedES;
	} else {
		eventSourceLink = feedVAL; 
	}


}


 


let posScroll  = 0; 

let currentOutScroll ;

let stopRender = false;

let miScroll;


let swiperPremios;

//VARS HOME
let iniSeconds;
let finSeconds;
let secsInADay;

let iniSec;
let finSec;

let selectedDate;

let anchoW;
let altoW;


		
let mesesDias = []; // meses_dias para guardar los eventos por mes 
let mesDiaSelected ;
let anioDiaSelected;
let mesDiaSelected_key ;
let totalMeses  = -1; // Total de meses ya que el objeto de los meses > funciones no me devuelve length

let mesRelationObject = []; // Array para guardar el índice de la array asociativa anio_mes de mesesDias
let swiperCalendar;
let contKeyPosition = 0;

let dia_next;
let dia_prev ;

let tmpActivoDia; 
let arrBotones;

let info_evento;
let in_info_evento;

let hoyMili;


let goToDia = 0 ;  
let contDia = 0;


let monthsOfYear = [
	'Gener',
	'Febrer',
	'Març',
	'Abril',
	'Maig',
	'Juny',
	'Juliol',
	'Agost',
	'Septembre',
	'Octubre',
	'Novembre',
	'Decembre',
	];




let monthsOfYearPeq = [
		'Gen',
		'Feb',
		'Mar',
		'Abr',
		'Mai',
		'Jun',
		'Jul',
		'Aug',
		'Sep',
		'Oct',
		'Nov',
		'Dec',
		];

let daysOfWeek = [  'Du', 'Dll', 'Dm', 'Dx', 'Dj', 'Dv', 'Ds'];	

//console.log('VAL!!!!');

//console.log(document.documentElement.lang);

if (document.documentElement.lang.indexOf("ES") !=-1) {

	//console.log('SPANISH!!!!');

	monthsOfYear = [
		'Enero',
		'Febrero',
		'Marzo',
		'Abril',
		'Mayo',
		'Junio',
		'Julio',
		'Agosto',
		'Septiembre',
		'Octubre',
		'Noviembre',
		'Diciembre',
		];
	monthsOfYearPeq = [
			'Ene',
			'Feb',
			'Mar',
			'Abr',
			'May',
			'Jun',
			'Jul',
			'Ago',
			'Sep',
			'Oct',
			'Nov',
			'Dic',
			];
	daysOfWeek = [ 'Do' ,'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'];	

}

let WeekList; 
let monthTitle;
let yearTitle;
let today;

//VARS HOME


//VARS SINGLE ESPECTAUCLO//

let swiperSingle;

 


//FIX TITS

var arrTitsAlt ;
var altCompare = 0 ;
 
		
function checkDate(_fecha,   auto = false){ 

	// //console.log('checkDate!!!!!!!!!');
		
    // //console.log('jsonListo');
    // //console.log(jsonListo);

    // //console.log('_fecha');
    // //console.log(_fecha);


  if(jsonListoDias[_fecha]){




      if(auto==true){

        let activoElement = document.querySelector('.calendar__container .swiper-slide-active');

          let posActElement = activoElement.getBoundingClientRect();


      } 

      in_info_evento.innerHTML = jsonListoDias[_fecha];

  } 

}


//BODY
(function () {
	'use strict';

	//console.log('!!!! HOME!!!');

		body = document.getElementsByTagName('body');
		body = body[0];

    if(body && body.classList.contains('calendar')){



		let calendar;

		let calendarEl = document.getElementById('calendar');
		let infoTemp = document.getElementById('calendarHor');



		let iniTemp = infoTemp.dataset.start;
		let finTemp = infoTemp.dataset.end;


		let fechaIniTemp = {
			'year' : iniTemp.substr(0,4),
			'month' : iniTemp.substr(4,2),
			'date' : iniTemp.substr(6,2),
		  }
		  
		  ////console.log(fechaIniTemp);
		  
		  let fechaFinTemp = {
			'year' : finTemp.substr(0,4),
			'month' : finTemp.substr(4,2),
			'date' : finTemp.substr(6,2),
		  }
		
			let iniFechaOk = `${fechaIniTemp['year']}-${fechaIniTemp['month']-1}-${fechaIniTemp['date']}`;
			let finFechaOk = `${fechaFinTemp['year']}-${fechaFinTemp['month']-1}-${fechaFinTemp['date']}`;
			////console.log('------------------------ ' + iniFechaOk + ' ' +finFechaOk );
			
		  iniSec = (setDate(setUTC(fechaIniTemp['year'], fechaIniTemp['month']-1, fechaIniTemp['date'])));
		  finSec = (setDate(setUTC(fechaFinTemp['year'], fechaFinTemp['month']-1, fechaFinTemp['date'])));
		
		
		  iniSeconds =  (setUTC(fechaIniTemp['year'], fechaIniTemp['month']-1, fechaIniTemp['date'])) ;
		  finSeconds =  (setUTC(fechaFinTemp['year'], fechaFinTemp['month']-1, fechaFinTemp['date'])) ;


		//console.log('!!!! iniSeconds !!!');

		//console.log(iniSeconds);
		
		  secsInADay = 24*60*60*1000;
		
		var date = new Date();
		var now_utc = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(),
						date.getUTCDate(), date.getUTCHours(),
						date.getUTCMinutes(), date.getUTCSeconds());
		
		
		
		
		let dateObj = new Date();
		  monthTitle = document.querySelector('.calendar__month__title');
		  yearTitle = document.querySelector('.calendar__month__smtitle');
		  today = document.querySelector('.calendar__month__lstitle');
		  WeekList = document.querySelector('#weekday');


							
							
		let getCurrentYear = dateObj.getFullYear();
		let getCurrentMonth = dateObj.getMonth() + 1;
		let getCurrentDate = dateObj.getDate();
		//let allDaysInMonth = new Date(getCurrentYear, getCurrentMonth, 0).getDate();
		
		
		let prevMes = document.getElementById('prev_mes');
		let nextMes = document.getElementById('next_mes');
		
		let arrMeses = new Array(prevMes, nextMes);
		
		Array.prototype.forEach.call(arrMeses, (mesBot)=>{
		
		  mesBot.addEventListener('click', (ev)=>{
			ev.preventDefault();
			cambiaMes(ev.currentTarget.id);
		
			info_evento.classList.add('d-none');
		
		
		  })
		
		})
		
		

		
		
		monthTitle.textContent = monthsOfYear[getCurrentMonth - 1] + ' ' + getCurrentYear;
		yearTitle.textContent = getCurrentYear;
		
				let _todayStr = `${daysOfWeek[dateObj.getDay()]} ${getCurrentDate}, ${
				  monthsOfYear[getCurrentMonth - 1]
				}, ${getCurrentYear}`;
				today.textContent = _todayStr;
		
				  selectedDate = new Date(
				  getCurrentYear,
				  getCurrentMonth ,
				  getCurrentDate
				);
		
				  hoyMili = selectedDate.getTime() ; 
		 



        } // SI CONTEINENE calendaar
 


})();




  

(function () {
	'use strict';

	
	body = document.getElementsByTagName('body');
	body = body[0];


	//console.log('HELLO!!!!');

	// Focus input if Searchform is empty
	[].forEach.call(document.querySelectorAll('.search-form'), (el) => {
		el.addEventListener('submit', function (e) {
			var search = el.querySelector('input');
			if (search.value.length < 1) {
				e.preventDefault();
				search.focus();
			}
		});
	});

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
	var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
		return new bootstrap.Popover(popoverTriggerEl, {
			trigger: 'focus',
		});
	});

	//console.log('soy body');
	//console.log(body);

	telon = document.getElementById('telon');

	if(telon){
		doTelon();
	}


	//.mySwiperHome



	if(document.querySelector('.mySwiperHome')){

		 console.log('!!!!!!!!!DO BANNER');

		 console.log(document.querySelector('.mySwiperHome'));
 
		doBanner();
	}

	if( body && body.classList.contains('home')){

		//console.log('comon do home!!!');
		//console.log(body);

		doHome();
 

	}
	if( body && body.classList.contains('page-template-template-quienes')){

		doQuienes();
 

	}

	if( body && body.classList.contains('page-template-template-premios')){

		doPremios();
 

	}

	if( body && body.classList.contains('page-template-template-premios-horizontal')){

		doPremiosHorizontal();
 

	}

	if( body && body.classList.contains('mostrar_3D')){

		//console.log('!!! BÁSICO 3D hago DO 3D!!!');

	 do3D();

 
	}


	let fancyItems= document.querySelectorAll('.fancybox');


	//console.log('>>>>>>>>>fancyItems');

	//console.log(fancyItems);
	
	if(fancyItems && fancyItems.length>0){

	 

		doFancy();

 
	}
 
	

	 
	window.onload = function(){




		
		if(document.querySelector('.hayScrollTrigger')){

			console.log('doScrollTrigger() !!!!!!!');

			doScrollTrigger();

		}

		if(document.querySelectorAll('.page-template-template-team').length>0 ){



			console.log('!!!page-template-template-team!!!!!');

			console.log(document.querySelectorAll('.page-template-template-team')  );


			doTeam();

		}


		//initSmooth();
		
		initParallax();


		
		fixMenu();

		resize();

		fixThings();

		//createGradient();

		initHome();

		doSplit();

		fixBibText();

			
		if(document.querySelector('.single-project')){

			console.log('HAGO COSAS');
		   doSingle();
	   }
	
		

			
	if(document.querySelector('.swiper-single-proy')){

		console.log('>>>>>>>>>>>>>>>>>>>>!!!!!!!!!DO BANNER');

	   doGalProy();
   }

   console.log('END onload!');

	}

	
})(); ///END ONLOAD


function fixBibText(){

	console.log('FIB TEXT');

	var arrCapsBib = document.querySelectorAll('.tp_publication_article');

	if(arrCapsBib && arrCapsBib.length>0){

		arrCapsBib.forEach(b=>{
			var miLink = b.querySelector('.tp_title_link');
			var miLinkRevista =  b.querySelector('a.tp_pub_list');

 

			miLink.href=miLinkRevista.href; 
			miLink.target="_blank";

		})


	}



	/*tp_title_link*/
	/*tp_pub_list*/


}


function doScrollTrigger(){

	console.log('DO SCROLL TRIGGER');


	var contMoire = document.querySelector('.cont_moire');
	var altMoire = contMoire.getBoundingClientRect();
	altMoire = altMoire.height;
	var imgMoire = document.querySelector('.in_cont_moire');

	gsap.to(imgMoire, {
		scrollTrigger: {
		trigger: "body",
		start: "top top",
		end: altMoire, 
		scrub: true,
		toggleActions: "restart pause resume pause"
	},
		y: "+=100" 
	});


	//  controller = new ScrollMagic.Controller({globalSceneOptions: {triggerHook: "onEnter", duration: "200%"}});

	// // build scenes
	// new ScrollMagic.Scene({triggerElement: "#parallax_moire"})
	// 				.setTween("#parallax_moire > .in_cont_moire", {y: "80%", ease: Linear.easeNone})
	// 				.addIndicators()
	// 				.addTo(controller);

}

var people_desta; 

function doTeam(){

	console.log('DO TEAM!!!!');

	  people_desta = document.querySelectorAll('.in_ficha');

	  people_desta = document.querySelector('#people_desta');

	var people_desta_top = people_desta.getBoundingClientRect();
	people_desta_top = people_desta_top.top;

	console.log('people_desta_top' + people_desta_top);

	var arrTeamClicks = document.querySelectorAll('.link_go_team');

	if(arrTeamClicks){

		arrTeamClicks.forEach(person=>{

			person.addEventListener('click', (ev)=>{
				ev.preventDefault(); 

				let tmpPeople = ev.currentTarget;
				let tmpAbro = tmpPeople.dataset.ficha;

				arrFichas.forEach(fi=>{
					fi.classList.add('oculto-ficha');
				});

				people_desta.classList.add('show_people');

				tmpAbro = document.querySelector('#'+tmpAbro);
				tmpAbro.classList.remove('oculto-ficha');

				
				console.log('people_desta_top' + people_desta_top);
				window.scrollTo(0, people_desta_top);


			})

		})


	}

	var arrCierraFichas = document.querySelectorAll('.img_cierra_ficha');

	if(arrCierraFichas && arrCierraFichas.length>0){

			arrCierraFichas.forEach(ci=>{
				ci.addEventListener('click', ev=>{
					ev.preventDefault;

					people_desta = document.querySelector('#people_desta');
					people_desta.classList.remove('show_people')


					arrFichas.forEach(fi=>{
						fi.classList.add('oculto-ficha');
					});



				})
			})



	}


}


function doSingle(){

	console.log('HAGO SINGLE!!');

	var arrDesplegables = document.querySelectorAll('.otra_info .tit_in_proy');




	arrDesplegables.forEach(desp=>{
		desp.addEventListener('click', ev=>{
			ev.preventDefault();

			console.log(ev.currentTarget);

			ev.currentTarget.classList.toggle('pest_open');

			let tmpDesp = ev.currentTarget.nextElementSibling ;

			console.log(tmpDesp);

			tmpDesp.classList.toggle('d-none');

		})
	});




	console.log('DO SINGLE');
	console.log(arrDesplegables);

}


let f_latin;
let f_es;
function initHome(){

	f_latin = document.getElementById('f_latin');
	f_es = document.getElementById('f_es');

	if(f_latin){

		f_latin.classList.add('aparece_t');
		
	}

	if(f_es){

		f_es.classList.add('aparece_t');
		
	}


}


function createGradient(){


//console.log('>>>>>>> !!!!!!!!!!!!!!!!CREATE GRADIENT !!!');

// Create your instance
const gradient = new Gradient()

// Call `initGradient` with the selector to your canvas
gradient.initGradient('#gradient-canvas');

//console.log('!!!!!!!!!!!!!!!!CREATE GRADIENT !!!');

}



function fixThings(){

	////console.log('fixThings GRID');

	//ARreglo títulos de menú //grid_espec_tit

	arrTitsAlt = document.querySelectorAll('.cont_altura');

	if(arrTitsAlt ){

		arrTitsAlt.forEach(( element, key)=>{
			// //console.log('elemento grid key');
			// //console.log(element);
			// //console.log('key');
			// //console.log(key);

			let tmpAlt = element.getBoundingClientRect();
			tmpAlt = tmpAlt.height;

			////console.log('ALT tmpAlt ' + tmpAlt + 'ALT COMPARE ' + altCompare);

			altCompare = Math.max(altCompare, tmpAlt);

			////console.log('ALT COMPARE ' + altCompare);

		})


		arrTitsAlt.forEach(( element, key)=>{
	
			element.style.minHeight = `${altCompare}px`;

		})
 
	}
 

	var arrTitsServ  = document.querySelectorAll('.grupo_in_servicios h2');
	var tmpAltServ = 0;

	
	////console.log('[-------] arrTitsServ '   );

	////console.log(arrTitsServ);
 
	if(arrTitsServ){


		arrTitsServ.forEach(( element, key)=>{
		

				let tmpAlt = element.getBoundingClientRect();
				tmpAlt = tmpAlt.height; 

				////console.log('tmpAlt > ' + tmpAlt );


				altCompare = Math.max(tmpAltServ, tmpAlt);
		

			});

			arrTitsServ.forEach(( element, key)=>{
		
				element.style.minHeight = `${altCompare}px`;

			})



	}


	//Iguala ALturas

	var arrNomsTeam = document.querySelectorAll('.eq_nom');
	var altNom = 0;

	if(arrNomsTeam.length>0){

		arrNomsTeam.forEach(n=>{
			var tmpBoxName = n.getBoundingClientRect();
			var tmpBoxAlt = tmpBoxName.height;

			altNom = Math.max(altNom, tmpBoxAlt);
		});

		arrNomsTeam.forEach(n=>{
			n.style.minHeight = altNom+'px';
		});

		console.log('ALT altNom');
		console.log(altNom);

	}

	var arrFotosTeam =document.querySelectorAll('.eq_team_foto');
	var altFot = 0;

	if(arrFotosTeam.length>0){

		arrFotosTeam.forEach(n=>{
			var tmpBoxFoto = n.getBoundingClientRect();
			var tmpBoxAlt = tmpBoxFoto.height;

			altFot = Math.max(altNom, tmpBoxAlt);
		});

		arrFotosTeam.forEach(f=>{
			f.style.minHeight = altFot+'px';
		});

		console.log('ALT FOTO');
		console.log(altFot);

	}

	////console.log('>>>>>>>> ARR TITULOS ALT');


	reposFotoKira();
	

	//console.log('END fixThings !!!!!!!!!!!');

}


function reposFotoKira(){



	//FOTO BOX 

	let infoQuien = document.getElementById('info_box_kira');
	let fotoQuien = document.getElementById('foto_box_kira');

	if(fotoQuien){

		infoQuien= infoQuien.getBoundingClientRect();
		//console.log('>>>>> topQui');
		//console.log(infoQuien);
		let topQui = infoQuien.top;
		let altQui = infoQuien.height;
		//console.log('ZZZZZZZZ topQui');
		//console.log(topQui);

		fotoQuien.style.top = topQui+'px';
		fotoQuien.style.height = altQui+'px';

		//console.log('END reposFotoKira !!!!!!!!!!!');


	}


	 

}



function doFancy(){

	//console.log('DO FANCY');

	Fancybox.bind("[data-fancybox]", {
		// Your custom options
	  });
}

function fixMenu(){

	//console.log('FIX MENU!!!');

	//menu-item-language

	var menuLang= document.querySelectorAll('.menu-item-language span[lang]');

	// var menuHeader = document.getElementById('menu-menu-principal');
	var menuHeader = document.querySelector('.menu_thunder');
	var movilRRSS = document.getElementById('rrss_thunder_header_movil');

	if(movilRRSS){
		if(menuHeader){
			var li = document.createElement("li");
			menuHeader.appendChild(li);
			li.appendChild( movilRRSS  ); 
		}



	}


	//console.log('menuLang');
	//console.log(menuLang);

	Array.prototype.forEach.call(menuLang ,(m)=>{

		let tmpIdio = m.lang;
		m.innerHTML = tmpIdio;
		m.classList.add('upperCase'); 
		m.classList.add('muevoLeft');

		//console.log('menulang');
		//console.log(m);
	})


	var arrMenuUpCont = document.querySelector('.navbar-nav li:last-child a');

	arrMenuUpCont.classList.remove('active');
 



}




function quitoActivo(_arr, _clase){


	//console.log('quitoActivo!!!!! ');

	Array.prototype.forEach.call(_arr, (b)=>{

		//console.log('QUITO!!!!! ' + _clase);
		//console.log(b);

		b.classList.remove(_clase);

	});
}


function doGalProy(){

	//console.log('>>>>>>>>>>>>>>>>>  DO GAL PROYECTO');


	var swiperGalProy = new Swiper('.swiper-single-proy', {
		speed: 600,
		slidesPerView: 3,
		autoplay: {
			delay: 5000,
		  },
		parallax: true, 
		navigation: {
		  nextEl: '.swiper-button-next-home',
		  prevEl: '.swiper-button-prev-home',
		},
		
	  });

	  swiperGalProy.on('slideChange', function () {
 
		//quitoActivo(arrBotonesBanners, 'activo');

 
		//arrBotonesBanners[(this.activeIndex)].classList.add('activo');

		 
	  });

	//   var arrBotonesBanners = document.querySelectorAll('.list_botonera a');
	//   Array.prototype.forEach.call(arrBotonesBanners, (b)=>{
	// 	//console.log('bbbbb ' + b);
	// 	b.addEventListener('click', (ev)=>{
	// 		ev.preventDefault();
	// 		quitoActivo(arrBotonesBanners, 'activo');
	// 		ev.currentTarget.classList.add('activo');
			
	// 		let slideGo = ev.currentTarget.dataset.cont;
	// 		//console.log('SLIDEGTO ' + slideGo);
	// 		swiperHome.slideTo(slideGo);

	// 	})
	//   })

}

function doBanner(){


	swiperHome = new Swiper('.mySwiperHome', {
		speed: 600,
		autoplay: {
			delay: 5000,
		  },
		parallax: true, 
		navigation: {
		  nextEl: '.swiper-button-next-home',
		  prevEl: '.swiper-button-prev-home',
		},
		
	  });

	  swiperHome.on('slideChange', function () {
 
		quitoActivo(arrBotonesBanners, 'activo');

 
		arrBotonesBanners[(this.activeIndex)].classList.add('activo');

		 
	  });

	  var arrBotonesBanners = document.querySelectorAll('.list_botonera a');



	  Array.prototype.forEach.call(arrBotonesBanners, (b)=>{
		//console.log('bbbbb ' + b);
		b.addEventListener('click', (ev)=>{
			ev.preventDefault();
			quitoActivo(arrBotonesBanners, 'activo');
			ev.currentTarget.classList.add('activo');
			
			let slideGo = ev.currentTarget.dataset.cont;
			//console.log('SLIDEGTO ' + slideGo);
			swiperHome.slideTo(slideGo);

		})
	  })
 

}

/*
const observer = new IntersectionObserver((entries, observer) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('active');
    } else {
      entry.target.classList.remove('active');
    }
  });
}, observerConfig);

sections.forEach(section => {
  observer.observe(section);
});

*/

let observerConfig ;

let observador;

var callbackScroll = function (entries, observer) {

	if(!entries){

		return;
	}

	entries.forEach((entry) => {

	

		if(entry.isIntersecting){
			//console.log('INTERSECTA');
			//console.log(entry.target); 

			entry.target.classList.add('entro_scroll');
			entry.target.classList.add('split_activo');

			//console.log('AÑADO  >>>>>>>>>>>>>>');

			//console.log(entry.target.classList);
		}else{


			entry.target.classList.remove('entro_scroll');
			entry.target.classList.remove('split_activo');

		}
	

	  // Cada entry describe un cambio en la intersección para
	  // un elemento observado
	  //   entry.boundingClientRect
	  //   entry.intersectionRatio
	  //   entry.intersectionRect
	  //   entry.isIntersecting
	  //   entry.rootBounds
	  //   entry.target
	  //   entry.time
	});
  };


function doSplit(){

	////console.log('doSplit >>>>>>> 00000');


	observerConfig = {
		root: null,
		rootMargin: '0px',
		threshold: 0.1
	  };

	  observador = new IntersectionObserver(callbackScroll, observerConfig);

	  var arrObservo = document.querySelectorAll('.triggerOnScroll');

	  arrObservo.forEach(ob=>{

		observador.observe(ob);

	//	//console.log(ob);


	  });

	  //https://splitting.js.org/guide.html#grid

	  Splitting({
		/* target: String selector, Element, Array of Elements, or NodeList */
		target: "[data-splitting]",
		/* by: String of the plugin name */
		by: "lines",
		/* key: Optional String to prefix the CSS variables */
		key: null
	  });

	  var inMaskArr = document.querySelectorAll('.splitting .word');

	  inMaskArr.forEach(inc=>{

		let tmpCont = inc.textContent;
		inc.innerHTML='';
		//let tmpSpan = document.createElement('span');
		inc.innerHTML+='<span class="in_mask_span">'+tmpCont+'</span>';
		//inc.appendChild(tmpSpan) ;


	  });

	//   //console.log('inMaskArr');

	//   //console.log(inMaskArr);
	

	//   //console.log(Splitting);;


}


function doHome(){

	
	////console.log('doHome');

		

 
 ////console.log(Swiper);



	// miJSON =   leeJSON(eventSourceLink);

	/*
    quote.anim = gsap.from(quote.split.chars, {
      scrollTrigger: {
        trigger: quote,
        toggleActions: "restart pause resume reverse",
        start: "top 50%",
      },
      duration: 0.6, 
      ease: "circ.out", 
      y: 80, 
      stagger: 0.02,
    });
	*/

 


}



function setDate(utc){

	let tmpDate =   new Date( utc );  
	return   tmpDate;
  
  
  
  }
  
  function setUTC(year,month , day){
  
	let now_utc =  new Date(year, month,day); 
	now_utc = now_utc.getTime(); 
	return now_utc; 
  }
  
  function date2Mili(fecha){

	//Sun Apr 23 2023 12:28:47 GMT+0200 (hora de verano de Europa central)
  
  
	let miFecha = new Date(fecha);
  
	////console.log('fecha.getMilliseconds()');
  
	////console.log(miFecha );
  
  
  }

function leeJSON(file){


	//console.log('>>>>>leo file');

	//console.log(file);

	let char = ':';


	let regex = /:/g;

	let total = (file.match(regex) || []).length;


 
	//console.log('total >>>>>>>>>>>' + total);
	let  firstIndex = file.indexOf(char); 
	let  secondIndex;

	if(total>1){

		secondIndex = file.indexOf(char, firstIndex + 1);

	}
 

    // Encontrar la posición de la segunda ocurrencia a partir de la posición anterior
 



    //console.log(secondIndex);
	if(secondIndex ){

		//console.log('hay puerto');

		let tmpFile = file;
		let posPort = tmpFile.indexOf(':');
		tmpFile = tmpFile.substring(0, secondIndex) + tmpFile.substring(secondIndex+5);
		file= tmpFile;
	}
 

	//console.log(file);
 

	fetch(file)
	.then(function (response) {
	  return response.json();
	})
	.then(function (data) {

		//console.log('data');
		//console.log(data);
   
  
		//console.log('arrancoCustomCalendar IN');

	   arrancoCustomCalendar();

	   //console.log('arrancoCustomCalendar OUT');
  
 
  
	  for (let i = 0; i < data.length; i++) {
  
 
			if(data[i].start){
	
			}


			////console.log('>>>>>>>>> data[i].start');
			////console.log(data[i].start);

			let tmpStart = data[i].start;
			let tmpEspacio = tmpStart.indexOf(' '); 
			let soloDia = tmpStart.substr(0 , tmpEspacio);
	
	
  
		if(!(jsonListo.hasOwnProperty(data[i].start))){
  
			jsonListo[data[i].start] = new Array();

			tmpStart = data[i].start; 
			tmpEspacio = tmpStart.indexOf(' '); 
			soloDia = tmpStart.substr(0 , tmpEspacio);
 

			if(!jsonListoDias[soloDia]){
				jsonListoDias[soloDia] = new Array(data[i].title);
 
			}else{
				jsonListoDias[soloDia].push(data[i].title);
			}
 
	
			let miDiaTmpPinto = document.getElementById(soloDia);
	
			if(miDiaTmpPinto){
	
				miDiaTmpPinto.classList.add('tengo_evento');
			}
	
  
		}
  
  
		 jsonListo[data[i].start].push(data[i].title);
  
 
	  }


 
  
		info_evento = document.getElementById('info_evento');
		in_info_evento = document.getElementById('in_info_evento');
  
  
	  //CLICK BOTONES CALENDAR

	  let weekday = document.getElementById('weekday');
	  let anchoWeekDay = weekday.getBoundingClientRect();

	  anchoWeekDay = anchoWeekDay.width;

  
		arrBotones = document.getElementsByClassName('tengo_evento');
 
  
		if(arrBotones && arrBotones.length>0){
	
			Array.prototype.forEach.call(arrBotones, (b)=>{
			b.addEventListener('click', (ev)=>{
				ev.preventDefault();
				

	
				let tmpPos = ev.currentTarget.getBoundingClientRect();
	
				let tmpPx =  (tmpPos.x + tmpPos.width/2); //anchoWeekDay -
				let tmpPy = 5 + tmpPos.height/2 ; //tmpPos.y + tmpPos.height/2;

				//////console.log('mando a ' + tmpPx + '  ' + tmpPy);
	
				info_evento.style.left = tmpPx +'px';
				info_evento.style.top = tmpPy +'px';
	
				info_evento.classList.remove('d-none');
	
	
				let fechaChek = ev.currentTarget.id;
	

				//console.log('checkDate');
				//console.log(fechaChek);
	
				checkDate(fechaChek);
	
	
	
			})
			}) //ARRAY
	
		}//IF
  
 
	})
	.catch(err => {
		//console.log('caught it!',err);
	 });
  
  } //leeJSON


  
  function arrancoCalendar(){


	calendar = new Calendar(calendarEl, {
	  initialView: 'dayGridMonth',
	  contentHeight: 500,
	  locale: esLocale,
	  editable: false,
	  selectable: false,
	  navLinks: true,
	  // events: 'https://fullcalendar.io/api/demo-feeds/events.json',
	  titleFormat: { // will produce something like "Tuesday, September 18, 2018"
		month: 'long',
		year: 'numeric', //
		// day: 'numeric',
		// weekday: 'long',
	  },
	  eventContent: function( arg ) {
		return { html: arg.event.title };
	 },
	  dateFormat: { // will produce something like "Tuesday, September 18, 2018"
		month: 'long',
		year: 'numeric', //
		// day: 'numeric',
		// weekday: 'long',
	  },
	  headerToolbar: {
		left: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek',
		center: 'title',
		right: 'prev,next',
	  },
	  eventSources: [


		/*
		  extraParams: {
			custom_param1: 'something',
			custom_param2: 'somethingelse',
		  },
		*/
		// your event source
		// url: 'http://localhost/pruebas/wp-json/eventos/search',
		{
		  url: eventSourceLink,
		  method: 'POST',

		  failure: function() {
			alert('there was an error while fetching events!');
		  },
		  color: 'yellow',   // a non-ajax option
		  textColor: 'black', // a non-ajax option
		},

		// any other sources...

	  ],


	})
	calendar.render();



  } //arrancoCalendar


  function cambiaMes(_dire){

	////console.log('mesDiaSelected ORI');
	////console.log(mesDiaSelected);
  
	////console.log('contKeyPosition ORI');
	////console.log(contKeyPosition);
  
  
  
  
	  switch(_dire){
  
		  case 'next_mes':
			mesDiaSelected++;
			contKeyPosition++;
		  break;
  
		  case 'prev_mes':
			mesDiaSelected--;
			contKeyPosition--;
		  break;
  
	  }
  
	  if(mesDiaSelected<0){
		mesDiaSelected = totalMeses ;
	  }
  
	  if( mesDiaSelected>totalMeses  ){
		mesDiaSelected = 0;
	  }
  
  
	  if(contKeyPosition<0){
		contKeyPosition = totalMeses ;
	  }
  
	  if( contKeyPosition>totalMeses  ){
		contKeyPosition = 0;
	  } 
  
	  let posSelected = mesRelationObject[contKeyPosition]
  
	  monthTitle.textContent = monthsOfYear[mesDiaSelected] + ' ' +mesesDias[posSelected].anio; 
  
	  swiperCalendar.slideTo(mesesDias[posSelected].diaEmpiezo); 
  
  }


  function arrancoCustomCalendar(){



	for (let d = iniSeconds; d <= finSeconds; d+=secsInADay) {

 
		let tmpCurrentDate = new Date(d);


	  let letTmpDate = ''+tmpCurrentDate.getFullYear()+tmpCurrentDate.getMonth()+tmpCurrentDate.getDate();
	  let letSelectadDate = ''+selectedDate.getFullYear()+(selectedDate.getMonth()-1)+selectedDate.getDate();
 
	  let numAnio = tmpCurrentDate.getFullYear() ;
	  let numMes = tmpCurrentDate.getMonth(); // meses-1
	  let numDia = tmpCurrentDate.getDate() ;

	  let tmpKeyMesAnio = ''+numAnio+'_'+(numMes+1);
 
	  if(!mesesDias[tmpKeyMesAnio]){


			mesRelationObject.push(tmpKeyMesAnio);
			mesesDias[tmpKeyMesAnio] = {} ;
			mesesDias[tmpKeyMesAnio].diaEmpiezo = contDia;
			mesesDias[tmpKeyMesAnio].mesOrden = numMes;
			mesesDias[tmpKeyMesAnio].mesNum = numMes+1;
			mesesDias[tmpKeyMesAnio].anio = numAnio;
			mesesDias[tmpKeyMesAnio].mesNom = monthsOfYear[numMes];
			mesesDias[tmpKeyMesAnio].dias = new Array();
			totalMeses++;



	  }


	  if(letTmpDate === letSelectadDate){

		goToDia = contDia; 

	   mesDiaSelected = numMes ; //meses-1
	   anioDiaSelected = numAnio;
	   ////console.log(anioDiaSelected);

	   mesDiaSelected_key = tmpKeyMesAnio; //numAnio+'_'+(numMes + 1 );
	   contKeyPosition = totalMeses;

	  } 

	  mesesDias[tmpKeyMesAnio].dias.push(''+numAnio+'_'+(numMes+1)+'_'+numDia);



	  let txtMes = numMes  + 1 ;

	  if(numMes<10){
		txtMes = '0'+ txtMes;
	  }

	  let txtAnio = numAnio;
	  let txtDia = numDia ;
	  if(txtDia<10){
		txtDia = '0' + txtDia;
	  } 


	  let _dateString = daysOfWeek[tmpCurrentDate.getDay()];
 

	  let cardString = `
	  <div id="${txtAnio}-${txtMes}-${txtDia}" data-dia="${contDia}"   data-mes="${txtMes}"  data-diames="${txtDia}"  data-anio="${txtAnio}" title='${_dateString} ${txtDia} ${txtMes}  ${txtAnio}' class='swiper-slide d-flex flex-column calendar__weekday__item '>
		<div class='${selectedDate === txtDia + 6 ? 'active-dot' : ''}' ></div>
		<div class="mini_fecha_dia">${_dateString}</div>
		<div class="mini_fecha_dia_num">${new Date(numAnio, numMes, numDia).getDate()}</div>
		<div class="mini_fecha_dia_mes">${  monthsOfYearPeq[numMes]  }</div>
	  </div>`;
	  WeekList.insertAdjacentHTML('beforeend', cardString);


	  contDia++;


	}

 

	  swiperCalendar = new Swiper('#swiperCal', {


	  slidesPerView: 3,
	  spaceBetween: 0,
	  initialSlide:goToDia,
	  centeredSlides:true,
	  allowTouchMove:false,


	  breakpoints: {
		640: {
		  slidesPerView: 5,
		  spaceBetween: 0,
		},
		768: {
		  slidesPerView: 7,
		  spaceBetween: 0,
		},
		1024: {
		  slidesPerView: 10,
		  spaceBetween: 0,
		},
		1600: {
		  slidesPerView: 15,
		  spaceBetween: 0,
		},
	  },
	});

 

	//BOTONES DÏAS

	dia_next = document.getElementById('dia_next');
	dia_prev = document.getElementById('dia_prev');


	dia_next.addEventListener('click', (ev)=>{
	  ev.preventDefault();
	  swiperCalendar.slideNext();
	  info_evento.classList.add('d-none');
	})
	dia_prev.addEventListener('click', (ev)=>{
	  ev.preventDefault();
	  swiperCalendar.slidePrev();
	  info_evento.classList.add('d-none');
	})

 

	swiperCalendar.on('slideChange', function () { 

		tmpActivoDia = swiperCalendar.slides[swiperCalendar.activeIndex]; 

		  let anioTmp = tmpActivoDia.dataset.anio;
		  let mesTmp = tmpActivoDia.dataset.mes; 

		  let mesTmpNom = monthsOfYear[Number(mesTmp)-1]; 

		  let diaTmp =  tmpActivoDia.dataset.diames;

		  monthTitle.textContent = mesTmpNom + ' ' + anioTmp ;

		  let indiceBusco = anioTmp+'-'+mesTmp+'-'+diaTmp

		//console.log('!!!!! VOY CHECKDATE!!!');

		  checkDate(indiceBusco , true);
 


	}); 
}   //arrancoCustomCalendar


function doQuienes(){

var galerias = document.querySelectorAll('.swiper_gallery');

var arrSwipers = [];

var cont = 0 ;

Array.prototype.forEach.call(galerias, (g)=>{

	let tmpID =  g.id;

	tmpID= tmpID.replace(' ', '');

	tmpID = '#' + tmpID;


	//console.log('>>>>> tmpID');

	//console.log(tmpID);


	let swiperGaleria = new Swiper(g, {

		slidesPerView: 1,
		spaceBetween: 10,
		centeredSlides: true,
		initialSlide:1,

		breakpoints: {
			// when window width is >= 320px
		 
			// when window width is >= 640px
			640: {
			  slidesPerView: 2,
			  spaceBetween: 40
			}, 
			1024: {
				slidesPerView: 2,
				spaceBetween: 40
			  }
		  },
		  navigation: {
			nextEl: tmpID+' .swip_gallery_right',
			prevEl: tmpID+' .swip_gallery_left',
		  },

 


	});


	arrSwipers.push(swiperGaleria);

		  /*

		  */

		//console.log(tmpID+' .swip_gallery_left');

		//console.log(tmpID+' .swip_gallery_right');
		let tmpBotIZQ = document.querySelectorAll(tmpID+' .swip_gallery_left');

		let tmpBotDER = document.querySelectorAll(tmpID+' .swip_gallery_right');

	

	if(tmpBotDER[0]){
		tmpBotDER[0].dataset.galeria = cont;// swiperGaleria;
		//console.log('HAY DER');
		tmpBotDER[0].addEventListener('click', (ev)=>{
			//console.log('DER');
			let tmpGal = Number(ev.currentTarget.dataset.galeria);
			//console.log('TMP GAL !!!!');
			//console.log(tmpGal);

			 arrSwipers[tmpGal].slideNext();
			//ev.preventDefault();
			//g.slideNext();
		  });

	  }


	  if(tmpBotIZQ[0]){
		//console.log('HAY IZQ');
		tmpBotIZQ[0].dataset.galeria = cont;// swiperGaleria;
		tmpBotIZQ[0].addEventListener('click', (ev)=>{
			//console.log('IZQ');
			let tmpGal = Number(ev.currentTarget.dataset.galeria);
			//console.log('TMP GAL !!!!');
			//console.log(tmpGal);

			 arrSwipers[tmpGal].slidePrev();
			//ev.preventDefault();

			//g.slidePrev();
		  })

	  }

	
	  cont++;

})


var swiperGaleria = document.getElementById('banner_galeria');



if(swiperGaleria){



	let swiperGaleriaGran = new Swiper(swiperGaleria, {

		slidesPerView: 1, 
		centeredSlides: true, 
		speed:600,
		autoplay: {
			delay: 5000,
		  }, 
 
	}); 


	var arrBotonesBannersGal = document.querySelectorAll('.list_botonera a');
	Array.prototype.forEach.call(arrBotonesBannersGal, (b)=>{
	  //console.log('bbbbb ' + b);
	  b.addEventListener('click', (ev)=>{
		  ev.preventDefault();
		  quitoActivo(arrBotonesBannersGal, 'activo');
		  ev.currentTarget.classList.add('activo');
		  
		  let slideGo = ev.currentTarget.dataset.cont;
		  //console.log('SLIDEGTO ' + slideGo);
		  swiperGaleriaGran.slideTo(slideGo);

	  })
	})

 
 

}


}//doQuienes

//PREMIOS

let arrImgPremios;
let arrImgPremiosIzq;
let arrImgPremiosDer;

//onclick="this.parentElement.style.display = 'none';">x</span>

function doPremios(){

	//console.log('PREMIOS');

	arrImgPremios = document.querySelectorAll('.cont_img_premio');


	arrImgPremiosIzq = document.querySelectorAll('.foto-par');
	arrImgPremiosDer = document.querySelectorAll('.foto-impar');

	Array.prototype.forEach.call(arrImgPremios, (imgPremio)=>{

		let tmpParentPremio = imgPremio.parentElement;



		let signo = 2*(  Math.round(Math.random()) - 0.5) ;

		//console.log('signo');

		//console.log(signo);

		if(signo<0){

			imgPremio.style.display = 'none'


		}


	});


	Array.prototype.forEach.call(arrImgPremiosIzq, (posPremio)=>{

		let px = Math.random()*50;
		let py = Math.random()*25;

		let signo = 2*(  Math.round(Math.random()) - 0.5) ;

		py*=signo;
 

		px*=-1 ;
		px+='%';
		py+='%';

		//console.log('>>>>>>>> PX IZQ '+px +'  ' +py);

		posPremio.style.transform =  'translate('+px+', '+py+')';


	});


	Array.prototype.forEach.call(arrImgPremiosDer, (posPremio)=>{

		let px = Math.random()*50;
		let py = Math.random()*25;

		let signo = 2*(  Math.round(Math.random()) - 0.5) ;

		py*=signo;

		//console.log(signo);

		px+='%';
		py+='%';

		//console.log('>>>>>>>> PX DER '+px +'  ' +py);

		posPremio.style.transform =  'translate('+px+', '+py+')';


	});
 
}//doPremios

function doPremiosHorizontal(){

	/*
		breakpoints: {
		  640: {
			slidesPerView: 5,
			spaceBetween: 0,
		  },
		  768: {
			slidesPerView: 7,
			spaceBetween: 0,
		  },
		  1024: {
			slidesPerView: 10,
			spaceBetween: 0,
		  },
		  1600: {
			slidesPerView: 15,
			spaceBetween: 0,
		  },
		},
	*/

 
 


	swiperPremios = new Swiper('#swiperPremiosHor', {


		slidesPerView: "auto",
		centeredSlides: true,
		spaceBetween: 0,  
		allowTouchMove:true,
  
  

	  });

	  //console.log('PREMIOS HORIZONTAL!!!');



	  var arrAltos = document.querySelectorAll('.info_premio_lado-impar');
	  var arrImpares = document.querySelectorAll('.premio-hor-impar');

	  var arrAltosPar = document.querySelectorAll('.info_premio_lado-par');
	  //info_premio_lado-par

	  var altTmp = 0;

	  if(window.innerWidth>=768){

				Array.prototype.forEach.call(arrAltos, (inf)=>{

					var bloq = inf.getBoundingClientRect();
					var tmpBloqAlt = bloq.height;


					altTmp = Math.max(altTmp, tmpBloqAlt);


				});

				//console.log('>>>>>>> ALTO TOTAL');
				//console.log(altTmp);
				//premio-hor-impar

				Array.prototype.forEach.call(arrImpares, (blo)=>{
					blo.style.paddingTop = altTmp+'px';
				});
				Array.prototype.forEach.call(arrAltosPar, (blo)=>{
					blo.style.height = altTmp+'px';
				});

				

	  }



}//doPremiosHorizontal



///SMOOTH WHEEL

//MOUSEWHEEL

function initSmooth(){

	//console.log('>>>>>>>>>>> initSmooth');


	new SmoothScroll(document,120,12)
  }
  
  function SmoothScroll(target, speed, smooth) {
	if (target === document)
	  target = (document.scrollingElement
				|| document.documentElement
				|| document.body.parentNode
				|| document.body) // cross browser support for document scrolling
  
	var moving = false
	var pos = target.scrollTop
	var frame = target === document.body
				&& document.documentElement
				? document.documentElement
				: target // safari is the new IE
  
	target.addEventListener('mousewheel', scrolled, { passive: false })
	target.addEventListener('DOMMouseScroll', scrolled, { passive: false })
  
	function scrolled(e) {
	  e.preventDefault(); // disable default scrolling
  
	  var delta = normalizeWheelDelta(e)
  
	  pos += -delta * speed
	  pos = Math.max(0, Math.min(pos, target.scrollHeight - frame.clientHeight)) // limit scrolling
  
	  if (!moving) update()
	}
  
	function normalizeWheelDelta(e){
	  if(e.detail){
		if(e.wheelDelta)
		  return e.wheelDelta/e.detail/40 * (e.detail>0 ? 1 : -1) // Opera
		else
		  return -e.detail/3 // Firefox
	  }else
		return e.wheelDelta/120 // IE,Safari,Chrome
	}
  
	function update() {
	  moving = true
  
	  var delta = (pos - target.scrollTop) / smooth
  
	  target.scrollTop += delta
  
	  if (Math.abs(delta) > 0.5)
		requestFrame(update)
	  else
		moving = false

		checkParallax(delta);
	}
  
	var requestFrame = function() { // requestAnimationFrame cross browser
	  return (
		window.requestAnimationFrame ||
		window.webkitRequestAnimationFrame ||
		window.mozRequestAnimationFrame ||
		window.oRequestAnimationFrame ||
		window.msRequestAnimationFrame ||
		function(func) {
		  window.setTimeout(func, 1000 / 50);
		}
	  );
	}()
  }
  
var arrParallax = document.querySelectorAll('.soyParallax');

let prePer =0 ;


function initParallax(){


	body = document.querySelector('body');




	window.addEventListener('scroll', function(){
		//amountscrolled()
 
		checkParallax();
	}, false);

	console.log('INIT PARALLAX');

	

  

}


  function checkParallax(delta){

 

	let per = 	scrollDesplazado();

	if(arrParallax.length>0){

	

		if(per!= prePer){

			//console.log(per);
				Array.prototype.forEach.call(arrParallax, (p)=>{

					// //console.log('p');

					let ratio =  Number(p.dataset.parallath);

					if(!ratio){
						ratio = 1;
					}
					

				
					
					p.style.transform = 'translate3D(0, '+ (-1*per*ratio)  + '%, 0)';

				});


		}

 

	}

//  console.log('per ' + per );

//  console.log('prePer ' + prePer );

 
if(body){				

		if(per >= prePer && per>=50){




			body.classList.add('despBaix');
		}else if(per<=50) { 



			body.classList.remove('despBaix');
		}


 }

	
	prePer = per;


 
 

  } //checkParallax


  function getDocHeight() {
	var D = document;
	return Math.max(
		D.body.scrollHeight, D.documentElement.scrollHeight,
		D.body.offsetHeight, D.documentElement.offsetHeight,
		D.body.clientHeight, D.documentElement.clientHeight
	)
}


  function amountscrolled(){
	var winheight= window.innerHeight || (document.documentElement || document.body).clientHeight
	var docheight = getDocHeight()
	var scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop
	var trackLength = docheight - winheight
	var pctScrolled = Math.floor(scrollTop/trackLength * 100) // gets percentage scrolled (ie: 80 or NaN if tracklength == 0)
	////console.log(pctScrolled + '% scrolled');

	// //console.log('logo3DOpaco');

	// //console.log(logo3DOpaco);

	// if(logo3DOpaco){
	// 	interact3D(pctScrolled , scrollTop);
	// }

	return(pctScrolled);



}


function scrollDesplazado(){
	var winheight= window.innerHeight || (document.documentElement || document.body).clientHeight
	var docheight = getDocHeight()
	var scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop
	//var trackLength = docheight - winheight
	//var pctScrolled = Math.floor(scrollTop/trackLength * 100) // gets percentage scrolled (ie: 80 or NaN if tracklength == 0)
	////console.log(pctScrolled + '% scrolled');

	// //console.log('logo3DOpaco');

	// //console.log(logo3DOpaco);

	// if(logo3DOpaco){
	// 	interact3D(pctScrolled , scrollTop);
	// }

	return(scrollTop);



}


//CLICK MENÚ

var arrMenuBots = document.querySelectorAll('.dropdown-toggle');

Array.prototype.forEach.call(arrMenuBots, (b)=>{
	b.addEventListener('click', (ev)=>{

		if(ev.target){

				//console.log('click > ');
				//console.log(ev); 
				//console.log(ev.target.tagName);

				if(body){
						if(body.classList.contains('show_menu')){
							body.classList.remove('show_menu');
						}else{
							body.classList.add('show_menu');
						}


						
				if(ev.target.tagName=='A'){

					//console.log('click AAA > ');
					//console.log(ev);

					if(ev.target.classList.contains('dropdown-toggle')){
						body.classList.add('show_menu')
					}
				}


				}





		}

 
	});
} );

document.addEventListener('click', (ev)=>{
	//console.log('document click');
	//console.log(ev.target.tagName);

	if(ev.target.tagName=='DIV'){
		if(body.classList.contains('show_menu')){
			body.classList.remove('show_menu')
		}
 
		//console.log('ev.currentTarget');
		//console.log(ev.target.classList);
		//console.log(ev.target);
		

		if(!ev.target.classList.contains('select-btn')){

				var hayFiltro = document.querySelectorAll('.select-btn.open')	;

				//console.log('hayFiltro');
				//console.log(hayFiltro);

				if(hayFiltro){
						
						//console.log('hayFiltro.childNodes.length');
						//console.log(hayFiltro.length);

						if(hayFiltro.length>0){
							//console.log('FILTRO ABIERTO');

							//console.log('HAY FILTRO');
							//console.log(hayFiltro);

							Array.prototype.forEach.call(hayFiltro, (f)=>{
								f.dispatchEvent(new Event('click'));
							})
						}

				}

		}

 

	}
 
}) //document.addEventListener('click'




window.addEventListener('resize', generalResize);

function generalResize(){

	//THREEJS 

	// anchoW = miCanvas.offsetWidth;
	// altoW = miCanvas.offsetHeight;
	//  renderer.setSize(anchoW , altoW);
	//  camera.aspect = anchoW/altoW;
	//  camera.updateProjectionMatrix();


	 //THREEJS 
}

var cont_ficha;

var extratelon ;
 

function doTelon(){

	//toggleActions: "restart pause resume pause"

	cont_ficha = document.getElementById('cont_ficha');;

	extratelon  = document.getElementById('extratelon');;
	hayTelon = true;

 

}

function resize(){

	//console.log('RESIZEEEEE!!!!!!!!!!!!!!!!!!!!');

	/*
let box = document.querySelector('.box');
let width = box.offsetWidth;
let height = box.offsetHeight;

	*/


	var arrVideos = document.querySelectorAll('.section_video iframe');

	Array.prototype.forEach.call(arrVideos, (vi)=>{

		var tmpAnch = Number(vi.width);
		var tmpAlt  = Number(vi.height);
		var prop = tmpAnch/tmpAlt

		//console.log('prop' + prop);

		vi.dataset.prop = prop;

		// var anchoTrue = vi.getBoundingClientRect();
		// anchoTrue = anchoTrue.width;

		// vi.style.height = (anchoTrue / prop)+'px';

		// //console.log( (anchoTrue / prop)+'px'   );


	})

}


function resizeo(){

	reposFotoKira();


}

window.addEventListener('resize', resizeo);

//HAY IMG HERO

var imgHERO = document.getElementById('imghero');

if(imgHERO){


gsap.to(imgHERO, {
	scrollTrigger: {
	trigger: "body",
	start: "top top",
	end: "bottom top", 
	scrub: true,
	toggleActions: "restart pause resume pause"
},
	y: "+=100" 
});

}



        